// ** react imports
import React from 'react';
import PropTypes from 'prop-types';

const UpdateQuiz = props => {
  // props
  const {} = props;

  return <div>UpdateQuiz</div>;
};

UpdateQuiz.propTypes = {};

export default UpdateQuiz;
